'use client'
import {Button, SmallText} from '@local/ui/components'
import {useState} from 'react'
import {cx} from '@local/utils/cx'
export interface RecommendationsSelectProps {
	destinations: string[]
}

export const RecommendationsSelect = ({destinations}: RecommendationsSelectProps) => {
	const [selectedDestination, setSelectedDestination] = useState<string>('')
	return (
		<>
			<div className='max-w-[620px] flex flex-row flex-wrap items-center justify-center gap-x-12 gap-y-12'>
				{destinations.map((destination) => (
					<button key={destination} className={cx('border border-grey-1 rounded-xs py-4 px-12', selectedDestination === destination && 'bg-white')} onClick={() => setSelectedDestination(destination)}>
						<SmallText className={cx('text-white', selectedDestination === destination && 'text-black')}>{destination}</SmallText>
					</button>
				))}
			</div>

			<a
				className='mt-20'
				href={`mailto:hello@kaer.co?subject=${encodeURIComponent('Recommendations')}&body=${encodeURIComponent(`I'm interested in recommendations for a trip to ${selectedDestination}.`)}`}>
				<Button className='mt-20' variant='secondary' small label='Get Recommendations' />
			</a>

		</>

	)
}
